import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InventoryLocationsDropdownComponent } from './inventory-locations-dropdown.component';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownWithOverlayOptionsListModule } from '../dropdown-with-overlay-options-list/dropdown-with-overlay-options-list.module';
import { ScrollingModule } from '@angular/cdk/scrolling';



@NgModule({
  declarations: [InventoryLocationsDropdownComponent],
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownWithOverlayOptionsListModule
  ],
  exports: [InventoryLocationsDropdownComponent]
})
export class InventoryLocationsDropdownModule { }
